// extracted by mini-css-extract-plugin
export var dropdownButton = "_1h-0";
export var fullWidthDropdownButton = "_1h-1";
export var icon = "_1h-3";
export var iconPlaceholder = "_1h-2";
export var menuItemRow = "_1h-8";
export var separator = "_1h-c";
export var shortcutContainer = "_1h-7";
export var shortcutIconLg = "_1h-6";
export var shortcutIconMd = "_1h-5";
export var shortcutIconSm = "_1h-4";
export var submenuChevron = "_1h-b";
export var submenuDropdown = "_1h-9";
export var submenuTriggerRow = "_1h-a";